import axiosClient from "./axiosClient";

const RenameLayerApi = {
    //ok
  async CreateJob(file) {
  const url = `/renamelayer`;
    return axiosClient.request({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      url: url,
      data: file,
    });
  },

  async DownloadFile(jobId) {
    const url = `/renamelayer/${jobId}/result/download`;
    return axiosClient.request({
      method: "GET",
      url: url,
      responseType: "blob",
    });
  },

  async RunRenameLayers(jobId, data) {
    const url = `/renamelayer/${jobId}`;
    return axiosClient.request({
      method: "POST",
      url: url,
      data: data,
    });
  },

  async GetResultUrn(jobId) {
    const url = `/renamelayer/${jobId}/result/urn`;
    return axiosClient.request({
      method: "GET",
      url: url,
    });
  },
//ok
  async RunGetLayerNameList(jobId) {
    const url = `renamelayer/layer-name-list/${jobId}`;
    return axiosClient.request({
      method: "POST",
      url: url,
    });
  },
  //ok
  async GetAllLayerName(jobId) {
    const url = `renamelayer/layer-name-list/${jobId}`;
    return axiosClient.request({
      method: "GET",
      url: url,
    });
  },
};

export default RenameLayerApi;
